import React, { useState, useEffect } from 'react';

// Define the global contact information and donation email here
const contactInfo = {
  address: "3701 Chesswood Dr suite 316, North York ON, Ca",
  phone: "(416) 999-9614",
  email: "eritreanparents@yahoo.ca",
  donationEmail: "eritreanparents@yahoo.ca"
};

// Global language content for the entire application (now only English)
const content = {
  en: {
    navbar: [
      { name: "Home", path: "home" },
      { name: "About Us", path: "about" },
      { name: "Services", path: "services" },
      { name: "Events", path: "events" },
      { name: "Contact", path: "contact" },
      { name: "Donate", path: "donate" }
    ],
    home: {
      hero: {
        title: "Welcome To The Eritrean Parents Liaison Council",
        subtitle: "Committed to building a vibrant community in which the success of the children is the priority in its agenda.",
        cta1: "Know More",
        cta2: "Donate Now",
        image: "https://i.imgur.com/T7F8YEy.jpeg"
      },
      aboutSummary: {
        title: "Who We Are",
        subtitle: "The Eritrean Parents Liaison Council (EPLC) is committed to building a vibrant community in which the success of the children is the priority in its agenda.",
        cards: [
          { icon: "fas fa-handshake", title: "Dignity", text: "We acknowledge and honor the fundamental value and dignity of all individuals." },
          { icon: "fas fa-balance-scale", title: "Equality", text: "Commitment to equitable treatment and elimination of discrimination in all its forms at all organizational levels and throughout all programs." },
          { icon: "fas fa-users", title: "Inclusivity", text: "Respect and value diverse life challenges, creating an environment that is inclusive of all." },
          { icon: "fas fa-award", title: "Rights", text: "Recognition of the rights of all individuals to mutual respect; acceptance of others without biases based on differences of any kind." },
          { icon: "fas fa-seedling", title: "Sustainability", text: "All our work will be guided by principles of Innovation, Health and Well-being; and Sustainability." }
        ],
        cta: "Read More About Us",
        image: "https://i.imgur.com/3br76lY.png"
      },
      servicesSummary: {
        title: "Our Services",
        subtitle: "We provide parenting services and support through workshops, courses and parent engagement resources to help build student success to parents and guardians across the GTA.",
        cards: [
          { icon: "fas fa-gavel", title: "Advocacy", text: "Providing guidance and support for parents to advocate effectively for their children's educational needs." },
          { icon: "fas fa-comments", title: "Counselling", text: "Offering compassionate counselling to help families navigate challenges and promote well-being." },
          { icon: "fas fa-book", title: "Information and Resources", text: "Access to vital information and educational resources to empower parents." },
          { icon: "fas fa-chalkboard-teacher", title: "Parenting Workshops", text: "Interactive workshops designed to equip parents with essential parenting skills and knowledge." },
          { icon: "fas fa-handshake-alt-slash", title: "Facilitating Communication Between Home and School", text: "Bridging gaps and fostering strong partnerships between families and educational institutions." }
        ],
        cta: "Explore All Services",
        image: "https://i.imgur.com/nbocjhH.jpeg"
      },
      africanChildrenSection: {
        title: "Joyful Futures: Empowering Our Youth",
        subtitle: "Witness the spirit and potential of the next generation, nurtured by a supportive community.",
        image: "https://i.imgur.com/oEJUXBA.jpeg"
      },
      eventsSummary: {
        title: "Upcoming Events",
        subtitle: "Join us for community gatherings, workshops, and programs designed to support Eritrean families.",
        events: [
          { month: "MAR", day: "10", title: "Test Today", location: "Toronto", description: "We happened to be staying at the hotel beside it and ventured over for lunch. The owner and staff are very nice, they are Jamaican [...]", image: "https://placehold.co/400x250/f0f8ff/6b00b3?text=Event+1" },
          { month: "APR", day: "10", title: "Admin Test 02", location: "Toronto", description: "Admin Test 02 Your content goes here. Edit or remove this text inline or in the module Content settings. You can also style every aspect [...]", image: "https://placehold.co/400x250/f0f8ff/6b00b3?text=Event+2" }
        ],
        cta: "View All Events"
      },
      testimonials: {
        title: "What Our Community Says",
        subtitle: "Hear directly from those whose lives we've touched and transformed.",
        items: [
          {
            quote: "EPLC has been an invaluable resource for our family. Their parenting workshops provided us with the tools and confidence to support our children's education in Canada.",
            name: "Fatima A.",
            role: "Parent",
            image: "https://placehold.co/80x80/dcdcdc/696969?text=FA"
          },
          {
            quote: "Volunteering with EPLC has been a truly rewarding experience. It's inspiring to see the direct impact their programs have on integrating newcomers.",
            name: "Ahmed S.",
            role: "Volunteer",
            image: "https://placehold.co/80x80/dcdcdc/696969?text=AS"
          },
          {
            quote: "The team at EPLC is incredibly dedicated. They helped me navigate the Canadian education system for my children and connected me with crucial community services.",
            name: "Zahara M.",
            role: "Newcomer Parent",
            image: "https://placehold.co/80x80/dcdcdc/696969?text=ZM"
          },
          {
            quote: "My internship at EPLC was fantastic! I honed my IT/tech support skills in a supportive environment, and it was rewarding to contribute to such a vital organization.",
            name: "Jacques Mofa",
            role: "IT/Tech Support Intern",
            image: "https://i.imgur.com/CisJfct.jpeg"
          }
        ]
      },
      callToAction: {
        title: "Join our mission. Volunteer, Donate, Advocate.",
        subtitle: "The Eritrean Parents Liaison Council is committed to building a vibrant community in which the success of the children is the priority in its agenda. Get started today!",
        cta1: "Get Started Today",
        cta2: "Support Our Work",
        image: "https://i.imgur.com/krqgyZC.png"
      }
    },
    about: {
      hero: {
        title: "About Us",
        subtitle: "Committed to building a vibrant community in which the success of the children is the priority in its agenda.",
        image: "https://i.imgur.com/DgclSsf.jpeg"
      },
      intro: {
        title: "About Eritrean Parents Liaison Council (EPLC)",
        paragraphs: [
          "The Eritrean Parents Liaison Council was established after a model was developed to facilitate the integration of newcomer African parents and their children, particularly of those of the Somali and Eritrean origin. EPLC was registered as a not-for-profit organization in 2006.",
          "The Eritrean Parents Liaison Council provides parenting services and support through workshops and courses and parent engagement resources to help build student success to parents and guardians across the GTA.",
          "EPLC also focuses on implementing programs and specifically offering services to newcomers, low-income families, visible minorities and socially excluded groups residing in Canada to improve their personal well-being and social-economic status.",
          "EPLC aims to work collaboratively with organizations and stakeholders through our grassroots network across the country."
        ],
        image: "https://i.imgur.com/3br76lY.png"
      },
      midPageImage: {
        title: "Our Community Impact",
        subtitle: "Working together to build a stronger future.",
        image: "https://i.imgur.com/4fku8n8.png"
      },
      visionMissionTagline: {
        visionTitle: "EPLC Vision",
        visionText: "Empower newcomer parents & their school age children to seamlessly integrate, thrive, settle & succeed!",
        missionTitle: "EPLC Mission",
        missionText: "To transform the lives of newcomer parents and children by providing programs and services through education, community engagement and integration in the Canadian community.",
        taglineTitle: "EPLC Tagline",
        taglineText: "Empowering new beginnings for newcomer parents and children!",
        visionIcon: "fas fa-eye",
        missionIcon: "fas fa-bullseye",
        taglineIcon: "fas fa-tags"
      },
      values: {
        title: "EPLC Values",
        subtitle: "These principles guide every action and decision at EPLC, ensuring our commitment to the community.",
        items: [
          { title: "Equity", description: "Commitment to equitable treatment and elimination of discrimination in all its forms at all organizational levels and throughout all programs.", icon: "fas fa-balance-scale" },
          { title: "Diversity", description: "Commitment to diversity in all staff, volunteers, and audiences, including full participation in programs, policy formulation, and decision-making.", icon: "fas fa-users-cog" },
          { title: "Rights", description: "Recognition of the rights of all individuals to mutual respect; acceptance of others without biases based on differences of any kind.", icon: "fas fa-gavel" },
          { title: "Respect", description: "Commitment to individual and organizational efforts to build respect, dignity, fairness, caring, equality, and self-esteem. We pledge ourselves to creating and maintaining an environment that respects diverse traditions, heritages, and experiences.", icon: "fas fa-hand-holding-heart" },
          { title: "Inclusivity", description: "Respect and value diverse life challenges, creating an environment that is inclusive of all.", icon: "fas fa-people-carry" },
          { title: "Dependability", description: "Assist clients to be self sufficient.", icon: "fas fa-shield-alt" },
          { title: "Honesty", description: "Commitment to honesty and backing it up with actions show respect for what's right and an esteem for ethical and moral integrity.", icon: "fas fa-lightbulb" },
          { title: "Transparency", description: "Recognizing to be authentic in the way we message ourselves internally and externally.", icon: "fas fa-binoculars" },
          { title: "Dignity", description: "We acknowledge and honor the fundamental value and dignity of all individuals.", icon: "fas fa-gem" }
        ]
      },
      guidingPrinciples: {
        title: "How Our Work is Guided",
        description: "All our work will be guided by: Innovation, Health and Well-being; and Sustainability.",
        image: "https://i.imgur.com/hHq7yjf.png"
      },
      boardOfDirectors: {
        title: "Our Board of Directors",
        subtitle: "The management and direction of the Corporation's business is vested in and exercised by a committed Board of Directors.",
        intro: "The Eritrean Parents Liaison Council (EPLC) Board of Directors are volunteers actively engaged in providing oversight, leadership, and strategic direction. They function to ensure that the organization’s activities are conducted with accountability and transparency, complying with applicable laws and legal requirements. This is done by monthly board meetings, active board committees, and ad-hoc committees formed on a need basis.",
        responsibilitiesSummary: "Key responsibilities include establishing strategic plans, ensuring sound financial management, overseeing policies and procedures, and ensuring proper performance of all legal obligations. Board members are elected by the members of the corporation and serve to promote EPLC’s objectives to the best of their ability.",
        members: [
          { name: "Nura Aman", title: "Executive Director", roleDetail: "Founder & Volunteer ED.", date: "Dec 16, 2022", image: "https://i.imgur.com/ZVQ32Ei.jpeg" },
          { name: "Nora Hachemi", title: "Board Chair", roleDetail: "Works in the settlement sector.", date: "Dec 16, 2022", image: "https://i.imgur.com/DtR4Ly0.jpeg" },
          { name: "Grace Diaz", title: "Secretary", roleDetail: "Marginalized Immigrant Neighbourhoods.", date: "Dec 16, 2022", image: "https://i.imgur.com/6SgaydA.jpeg" },
          { name: "Fouzia Noor", title: "Treasurer", roleDetail: "Career as an Employment Counsellor.", date: "Dec 16, 2022", image: "https://i.imgur.com/4DWIsfE.jpeg" },
          { name: "Annette Gordan", title: "Board Member at Large", roleDetail: "Provides parenting services.", date: "Dec 16, 2022", image: "https://i.imgur.com/dDxMx1S.jpeg" },
          { name: "Yasin Awed", title: "Board Member at Large", roleDetail: "Experienced IT professional.", date: "Dec 16, 2022", image: "https://i.imgur.com/704syOe.jpeg" },
        ]
      },
      affiliatesAndFunders: {
        title: "Our Affiliates & Funders",
        subtitle: "We gratefully acknowledge the organizations and funders who support EPLC's vital work.",
        affiliatesIntro: "The Affiliates below are organizations and businesses who supported the work of EPLC over the years. The Board of Directors of EPLC acknowledge the great contribution of the affiliates for their wisdom, expertise, providing space, assisting with promotion and publicity.",
        fundersIntro: "The Executive Director and the Board wish to acknowledge and appreciate the financial contribution of the funders. We would have never been able to do what we do without your contribution.",
        logos: [
          "https://i.imgur.com/H5wzp6k.png",
          "https://i.imgur.com/bBaM5NX.png",
          "https://i.imgur.com/ELXFy9V.png",
          "https://i.imgur.com/6Bfe0zC.png",
          "https://i.imgur.com/cPTtx7F.png",
          "https://i.imgur.com/XFAVXRe.png",
          "https://i.imgur.com/3ftaVW0.png",
          "https://i.imgur.com/ppmzrQz.png",
          "https://i.imgur.com/ErDuTGY.png",
          "https://i.imgur.com/E7n8kH8.png",
          "https://i.imgur.com/NcWzvRA.png",
          "https://i.imgur.com/HdWfUzw.png",
          "https://i.imgur.com/HdWfUzw.png",
          "https://i.imgur.com/FOhMxt1.png",
          "https://i.imgur.com/RXPf36t.png",
          "https://i.imgur.com/cPTtx7F.png",
          "https://i.imgur.com/cPTtx7F.png",
          "https://i.imgur.com/wtUF2tx.png"
        ],
        image: "https://i.imgur.com/3br76lY.png"
      },
      strategicPriorities: {
        title: "EPLC 2025 Strategic Priorities",
        subtitle: "Our roadmap for growth and enhanced community impact.",
        items: [
          "Fundraising strategies",
          "Space improvement (obtaining office space, including Music Studio for Youth, Youth / Family Lounge, Computer Lab, Arabic / cultural classes, increased security, weekly Podcast)",
          "Partnerships",
          "Policies (strengthen governance)",
          "Review program objectives to improve organizational capacity.",
          "Develop winning grant projects and programs.",
          "Closing the gaps in social disparities affecting marginalized Eritrean",
          "Increase student & general volunteers.",
          "Strategic Fundraising Plan",
          "Social Enterprise Development",
          "Board and staff training",
          "Marketing / Branding",
          "Program effectiveness"
        ],
        image: "https://i.imgur.com/bHaapN6.png"
      }
    },
    services: {
      hero: {
        title: "Our Services",
        subtitle: "Committed to building a vibrant community in which the success of the children is the priority in its agenda.",
        image: "https://i.imgur.com/s4nM3UK.png"
      },
      intro: {
        title: "Empowering Families Through Comprehensive Services",
        subtitle: "We provide parenting services and support through workshops, courses and parent engagement resources to help build student success to parents and guardians across the GTA.",
        items: [
          "Advocacy",
          "Counselling",
          "Information and Resources",
          "Parenting Workshops",
          "Facilitating Communication Between Home and School"
        ],
        image: "https://i.imgur.com/hHq7yjf.png"
      },
      midPageImage: {
        title: "Impactful Programs",
        subtitle: "Our services are designed to meet the diverse needs of our community.",
        image: "https://i.imgur.com/ufzpBrR.png"
      },
      detailedServices: {
        title: "How We Can Help: Programs & Support",
        subtitle: "Discover the comprehensive support and programs we offer to empower Eritrean families and foster successful integration.",
        items: [
          {
            title: "Advocacy",
            description: "Providing guidance and support for parents to advocate effectively for their children's educational needs and rights within the school system. This includes understanding policies, attending meetings, and ensuring equitable treatment.",
            icon: "fas fa-gavel"
          },
          {
            title: "Counselling",
            description: "Offering compassionate and confidential counselling services to help families navigate personal, social, and emotional challenges. Our goal is to promote mental well-being and strengthen family units. (From Strategic Plan: Includes a dedicated Counselling program)",
            icon: "fas fa-comments"
          },
          {
            title: "Information & Resources",
            description: "Providing a central hub for crucial information and resources on educational pathways, special education services, community support programs, and governmental assistance for newcomers and established families.",
            icon: "fas fa-book"
          },
          {
            title: "Parenting Workshops",
            description: "Engage in interactive workshops covering a range of topics from effective communication with children to navigating teenage years and fostering academic success at home. Workshops are designed to be practical and empowering.",
            icon: "fas fa-chalkboard-teacher"
          },
          {
            title: "Facilitating Communication Between Home and School",
            description: "Bridging the communication gap between Eritrean families and school staff. We help parents understand school reports, participate in parent-teacher conferences, and build strong, collaborative relationships with educators.",
            icon: "fas fa-handshake-alt-slash"
          },
          {
            title: "School-Age Children Curricula Programs",
            description: "Developing and implementing curricula tailored for school-age children, focusing on foundational learning and skill development to support their academic journey.",
            icon: "fas fa-school"
          },
          {
            title: "After School Programs",
            description: "Offering structured after-school activities that provide academic support, enrichment, and a safe environment for children and youth.",
            icon: "fas fa-afterschool"
          },
          {
            title: "March Break & Summer Programs",
            description: "Providing engaging and educational programs during school breaks to keep children active and learning, including March Break and summer holiday sessions.",
            icon: "fas fa-umbrella-beach"
          },
          {
            title: "Youth Programs",
            description: "Dedicated programs for youth, fostering leadership skills, personal development, and community engagement to help them thrive.",
            icon: "fas fa-child"
          },
          {
            title: "Women’s Program",
            description: "Supporting women with resources, workshops, and community connections to enhance their well-being, skills, and integration.",
            icon: "fas fa-female"
          },
          {
            title: "Gang and Gun Prevention",
            description: "Initiatives focused on educating and empowering youth to avoid gang involvement and promote a safer community.",
            icon: "fas fa-peace"
          },
          {
            title: "Employment & Career Counselling",
            description: "Providing comprehensive employment support, including career counselling, resume building, and job search assistance to enhance socio-economic status.",
            icon: "fas fa-briefcase"
          },
          {
            title: "STEM Program (Science, Technology, Engineering, Mathematics)",
            description: "Promoting engagement and learning in STEM fields for school-age children and youth, fostering critical thinking and future career pathways.",
            icon: "fas fa-atom"
          },
          {
            title: "Mentorship Program",
            description: "Connecting newcomers and youth with experienced mentors to provide guidance, support, and facilitate successful integration.",
            icon: "fas fa-user-friends"
          },
          {
            title: "Financial Literacy Program",
            description: "Equipping families with essential knowledge and skills in financial management, budgeting, and planning for a stable future.",
            icon: "fas fa-money-check-alt"
          },
          {
            title: "Volunteer Opportunities for Newcomers & Youth",
            description: "Providing avenues for community members, especially newcomers and youth, to volunteer, gain experience, and contribute to EPLC's mission.",
            icon: "fas fa-hands-helping"
          }
        ]
      }
    },
    events: {
      hero: {
        title: "EPLC Events",
        subtitle: "Committed to building a vibrant community in which the success of the children is the priority in its agenda.",
        image: "https://i.imgur.com/4fku8n8.png"
      },
      midPageImage: {
        title: "Community Gatherings",
        subtitle: "Moments of connection and shared experiences.",
        image: "https://i.imgur.com/pR3tiEC.jpeg"
      },
      sections: [
        {
          heading: "Upcoming Events",
          subtitle: "Mark your calendars and join us for our next community activities and gatherings. Please note some events are placeholders from the old site and will be updated with actual details.",
          events: [
            { month: "MAR", day: "10", title: "Test Today (Placeholder)", location: "Toronto", description: "This is a placeholder event from the old website. Actual event details will be updated here.", image: "https://placehold.co/400x250/e0f0ff/6b00b3?text=Upcoming+Event+1" },
            { month: "APR", day: "10", title: "Admin Test 02 (Placeholder)", location: "Toronto", description: "Admin Test 02 Your content goes here. Edit or remove this text inline or in the module Content settings. You can also style every aspect [...]", image: "https://placehold.co/400x250/e0f0ff/6b00b3?text=Upcoming+Event+2" },
            { month: "MAY", day: "19", year: "2023", time: "7:00 PM - 10:00 PM", venue: "Amano’s Restaurant", title: "Admin Test 01 (Placeholder)", description: "This is a placeholder event from the old website. Actual event details will be updated here.", image: "https://placehold.co/400x250/e0f0ff/6b00b3?text=Upcoming+Event+3" },
            { month: "JUN", day: "30", year: "2023", time: "7:00 PM - 10:00 PM", venue: "Amano’s Restaurant", title: "Spotlight Caribbean (Placeholder)", description: "This is a placeholder event from the old website. Actual event details will be updated here.", image: "https://placehold.co/400x250/e0f0ff/6b00b3?text=Upcoming+Event+4" }
          ]
        },
        {
          heading: "Past Event Highlights",
          subtitle: "A look back at some of our successful community engagements.",
          events: [
            { month: "JAN", day: "15", year: "2023", title: "Annual Gala", description: "Our annual fundraising gala was a huge success, bringing together community leaders and supporters.", image: "https://placehold.co/400x250/e0f0ff/6b00b3?text=Annual+Gala+2023" },
            { month: "FEB", day: "20", year: "2023", title: "Youth Workshop Series", description: "A series of workshops empowering youth with leadership and digital skills.", image: "https://placehold.co/400x250/e0f0ff/6b00b3?text=Youth+Workshop+2023" },
            { month: "MAR", day: "05", year: "2023", title: "Community Fair", description: "A vibrant community fair showcasing local talent and services.", image: "https://placehold.co/400x250/e0f0ff/6b00b3?text=Community+Fair+2023" },
            { month: "APR", day: "12", year: "2023", title: "Parents' Forum", description: "An open forum for parents to discuss challenges and share experiences.", image: "https://placehold.co/400x250/e0f0ff/6b00b3?text=Parents+Forum+2023" }
          ]
        },
        {
          heading: "Outreach & Seminars",
          subtitle: "Connecting with the community through informative sessions and local initiatives.",
          events: [
            { month: "JUN", day: "01", year: "2022", title: "Health & Wellness Seminar", description: "Expert-led seminar on mental and physical well-being for families.", image: "https://placehold.co/400x250/e0f0ff/6b00b3?text=Health+Seminar" },
            { month: "JUL", day: "10", year: "2022", title: "Back to School Drive", description: "Collecting and distributing school supplies to prepare children for the new academic year.", image: "https://placehold.co/400x250/e0f0ff/6b00b3?text=School+Drive" }
          ]
        },
        {
          heading: "Youth & Children Programs",
          subtitle: "Fostering growth and development through engaging activities for our younger community members.",
          events: [
            { month: "AUG", day: "05", year: "2022", title: "Summer Camp Fun Day", description: "A day filled with games, activities, and laughter for children in our summer program.", image: "https://placehold.co/400x250/e0f0ff/6b00b3?text=Summer+Camp" },
            { month: "SEP", day: "15", year: "2022", title: "STEM Workshop", description: "Hands-on STEM activities designed to spark curiosity and learning in young minds.", image: "https://placehold.co/400x250/e0f0ff/6b00b3?text=STEM+Workshop" }
          ]
        }
      ]
    },
    contact: {
      hero: {
        title: "Contact Us",
        subtitle: "We are here to help. Get in touch with the Eritrean Parents Liaison Council.",
        image: "https://i.imgur.com/8fqeZtl.jpeg"
      },
      getInTouch: {
        title: "Get In Touch",
        description: "If you'd like to reach out to us or simply send us a message, please enter your details and the nature of your message below. We will get back to you within 24-48 hours.",
        phoneContact: "Feel free to call us during business hours for immediate assistance.",
        image: "https://i.imgur.com/wtUF2tx.png"
      },
      midPageImage: {
        title: "Connect With Us",
        subtitle: "Reach out and let's make a difference together.",
        image: "https://i.imgur.com/J1eqfa7.png"
      },
      visitOffice: {
        title: "Visit Our Office",
        description: "Our office provides access to several of our programs and resources in person. We welcome you during our office hours.",
        officeHours: [
          "Monday – Friday: 9:00 AM – 5:00 PM",
          "Saturdays: 11:00 AM – 5:00 PM",
          "Sundays: 9:00 AM – 3:00 PM"
        ],
        mapPlaceholder: "https://placehold.co/600x400/f5e9fe/8c3bb4/FFFFFF?text=Office+Location",
        officeImage: "https://i.imgur.com/ufzpBrR.png",
        accessibilityNote: "We are committed to providing an accessible environment. Please contact us in advance if you have any special requirements."
      },
      faq: {
        title: "Frequently Asked Questions",
        subtitle: "If you have any questions regarding our services and programs, please review our FAQ. If you don't find what you're looking for, please send us a quick note by filling out the contact form.",
        questions: [
          {
            question: "What is the main focus of EPLC?",
            answer: "EPLC aims to enhance the lives of newcomer parents, school-age children, and families, particularly those of Somali and Eritrean origin, residing in the GTA and Ontario. Our objective is to facilitate their seamless integration, well-being, and socio-economic status."
          },
          {
            question: "How does EPLC support educational success?",
            answer: "We provide parenting support services, resources through workshops and courses, and parent engagement resources. This includes facilitating communication between home and school, technology training, and offering programs during school breaks like March Break and summer holidays."
          },
          {
            question: "Is EPLC a non-profit organization?",
            answer: "Yes, EPLC was registered as a not-for-profit organization in 2006. All revenues are used solely for the promotion of the Corporation's objectives, with no pecuniary gain for individuals."
          },
          {
            question: "How can I get involved or volunteer?",
            answer: "EPLC offers volunteer opportunities for newcomers, youth, and other community members. You can reach out to us via our contact form or phone to inquire about current opportunities and how you can contribute to our mission."
          },
          {
            question: "Does EPLC offer services in multiple languages?",
            answer: "The organization aims to have a fully functional Arabic / Tigrinya / Tigre program addressing these communities in the GTA, and currently, there is on-site Arabic, Tigrinya, and Tigre speaking personnel. The website also supports language switching for English, French, and Arabic."
          },
          {
            question: "How can I make a donation to EPLC?",
            answer: "As a not-for-profit organization, EPLC relies on community support. You can make a donation via e-transfer or PayPal by using our donation email: " + contactInfo.donationEmail + ". A 'Donate Now' button is available on the website for easy access."
          }
        ]
      }
    }
  }
};


// Placeholder for a generic Hero component (common to multiple pages)
const Hero = ({ title, subtitle, image }) => (
  <section
    className="bg-purple-600 text-white py-20 rounded-lg shadow-lg mb-8 mx-4 md:mx-auto max-w-7xl relative overflow-hidden"
    style={{ backgroundImage: `url(${image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
  >
    <div className="absolute inset-0 bg-black opacity-40 rounded-lg"></div> {/* Overlay for text readability */}
    <div className="container mx-auto px-4 text-center relative z-10">
      <h1 className="text-4xl md:text-5xl font-bold mb-4 rounded-lg">{title}</h1>
      <p className="text-xl md:text-2xl font-light">{subtitle}</p>
    </div>
  </section>
);

// Placeholder for Card component (used in AboutSummary, ServicesSummary)
const Card = ({ icon, title, text }) => (
  <div className="bg-white rounded-lg shadow-lg p-6 text-center transition-transform transform hover:scale-105 duration-300 flex flex-col items-center">
    {icon && <i className={`${icon} text-purple-600 text-5xl mb-4`}></i>}
    <h3 className="text-xl font-semibold text-gray-800 mb-2">{title}</h3>
    <p className="text-gray-600">{text}</p>
  </div>
);

// --- Component: Header ---
const Header = ({ currentPage, setCurrentPage, navbarContent, contactInfo }) => {
  const [isOpen, setIsOpen] = useState(false); // State for mobile menu

  return (
    <header className="bg-purple-700 text-white shadow-lg sticky top-0 z-50 rounded-b-lg">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center space-x-2">
          <a href="#" onClick={() => setCurrentPage('home')} className="text-2xl font-bold flex items-center gap-2">
            <img src="https://i.imgur.com/avAoEhi.png" alt="EPLC Logo" className="rounded-full" />
            EPLC
          </a>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-6">
          {navbarContent.map((item) => (
            <a
              key={item.path}
              href="#"
              onClick={() => setCurrentPage(item.path)}
              className={`text-lg hover:text-purple-200 transition duration-300 ${
                currentPage === item.path ? 'font-bold text-purple-100' : ''
              }`}
            >
              {item.name}
            </a>
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <div className="flex items-center space-x-4">
          <button
            className="md:hidden text-white text-2xl focus:outline-none"
            onClick={() => setIsOpen(!isOpen)}
          >
            <i className={isOpen ? "fas fa-times" : "fas fa-bars"}></i>
          </button>
        </div>
      </div>

      {/* Mobile Navigation (Dropdown) */}
      {isOpen && (
        <div className="md:hidden bg-purple-800 py-2 px-4 rounded-b-lg">
          <nav className="flex flex-col space-y-2">
            {navbarContent.map((item) => (
              <a
                key={item.path}
                href="#"
                onClick={() => {
                  setCurrentPage(item.path);
                  setIsOpen(false); // Close menu on item click
                }}
                className={`block px-3 py-2 text-lg hover:bg-purple-700 rounded-md transition duration-300 ${
                  currentPage === item.path ? 'font-bold text-purple-100' : ''
                }`}
              >
                {item.name}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

// --- Component: Footer ---
const Footer = ({ contactInfo }) => {
  return (
    <footer className="bg-gray-800 text-white py-8 mt-auto rounded-t-lg shadow-inner">
      <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Contact Info */}
        <div>
          <h3 className="text-xl font-bold mb-4">Contact Us</h3>
          <p className="flex items-center mb-2">
            <i className="fas fa-map-marker-alt mr-2"></i> {contactInfo.address}
          </p>
          <p className="flex items-center mb-2">
            <i className="fas fa-phone mr-2"></i> {contactInfo.phone}
          </p>
          <p className="flex items-center">
            <i className="fas fa-envelope mr-2"></i> {contactInfo.email}
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-xl font-bold mb-4">Quick Links</h3>
          <ul>
            <li className="mb-2"><a href="#" className="hover:text-purple-400 transition-colors">Home</a></li>
            <li className="mb-2"><a href="#" className="hover:text-purple-400 transition-colors">About Us</a></li>
            <li className="mb-2"><a href="#" className="hover:text-purple-400 transition-colors">Services</a></li>
            <li><a href="#" className="hover:text-purple-400 transition-colors">Events</a></li>
          </ul>
        </div>

        {/* Social Media & Donation */}
        <div>
          <h3 className="text-xl font-bold mb-4">Connect & Support</h3>
          <div className="flex space-x-4 mb-4">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-purple-400 transition-colors">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-purple-400 transition-colors">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-purple-400 transition-colors">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
          <a
            href={`mailto:${contactInfo.donationEmail}?subject=Donation to EPLC`}
            className="inline-block bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded-md shadow-md transition-colors"
          >
            Donate Now
          </a>
        </div>
      </div>
      <div className="text-center mt-8 pt-4 border-t border-gray-700">
        <p>&copy; {new Date().getFullYear()} Eritrean Parents Liaison Council. All rights reserved.</p>
      </div>
    </footer>
  );
};

// --- Page: Home ---
const Home = ({ content, contactInfo }) => {
  return (
    <div className="bg-gray-50">
      {/* Hero Section */}
      <Hero title={content.hero.title} subtitle={content.hero.subtitle} image={content.hero.image} />
      <div className="container mx-auto px-4 pb-12">
        <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4 mb-16">
          <a href="#" className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-6 rounded-md shadow-lg text-center transition-colors">
            {content.hero.cta1}
          </a>
          <a
            href={`mailto:${contactInfo.donationEmail}?subject=Donation to EPLC`}
            className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-md shadow-lg text-center transition-colors"
          >
            {content.hero.cta2}
          </a>
        </div>

        {/* About Summary Section */}
        <section className="py-16 bg-white rounded-lg shadow-lg mb-12 flex flex-col lg:flex-row items-center justify-center gap-8 px-8">
          <div className="lg:w-1/2">
            <h2 className="text-3xl font-bold text-gray-800 mb-4 text-center lg:text-left">{content.aboutSummary.title}</h2>
            <p className="text-lg text-center lg:text-left text-gray-600 mb-10">{content.aboutSummary.subtitle}</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              {content.aboutSummary.cards.map((card, index) => (
                <Card key={index} icon={card.icon} title={card.title} text={card.text} />
              ))}
            </div>
            <div className="text-center lg:text-left">
              <a href="#" className="inline-block bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-6 rounded-md shadow-lg transition-colors">
                {content.aboutSummary.cta}
              </a>
            </div>
          </div >
          <div className="lg:w-1/2 flex justify-center">
            <img src={content.aboutSummary.image} alt="About Us Overview" className="rounded-lg shadow-md w-full max-w-md h-auto" />
          </div>
        </section>

        {/* Services Summary Section */}
        <section className="py-16 bg-gradient-to-r from-purple-500 to-purple-700 text-white rounded-lg shadow-lg mb-12 flex flex-col lg:flex-row-reverse items-center justify-center gap-8 px-8">
          <div className="lg:w-1/2">
            <h2 className="text-3xl font-bold text-center lg:text-right mb-4">{content.servicesSummary.title}</h2>
            <p className="text-lg text-center lg:text-right mb-10">{content.servicesSummary.subtitle}</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              {content.servicesSummary.cards.map((card, index) => (
                <Card key={index} icon={card.icon} title={card.title} text={card.text} />
              ))}
            </div>
            <div className="text-center lg:text-right">
              <a href="#" className="inline-block bg-white text-purple-700 hover:bg-gray-100 font-bold py-3 px-6 rounded-md shadow-lg transition-colors">
                {content.servicesSummary.cta}
              </a>
            </div>
          </div>
          <div className="lg:w-1/2 flex justify-center">
            <img src={content.servicesSummary.image} alt="Our Services Summary" className="rounded-lg shadow-md w-full max-w-md h-auto" />
          </div>
        </section>

        {/* New Section: African Children Playing */}
        <section className="py-16 bg-white rounded-lg shadow-lg mb-12 text-center px-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">{content.africanChildrenSection.title}</h2>
          <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto">{content.africanChildrenSection.subtitle}</p>
          <div className="flex justify-center mb-8">
            <img src={content.africanChildrenSection.image} alt="African Children Playing" className="rounded-lg shadow-md w-full max-w-2xl h-auto object-cover" />
          </div>
        </section>

        {/* Events Summary Section */}
        <section className="py-16 bg-white rounded-lg shadow-lg mb-12">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-4">{content.eventsSummary.title}</h2>
          <p className="text-lg text-center text-gray-600 mb-10 max-w-3xl mx-auto">{content.eventsSummary.subtitle}</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-8">
            {content.eventsSummary.events.map((event, index) => (
              <div key={index} className="bg-gray-100 rounded-lg shadow-md p-6 flex flex-col">
                {event.image && <img src={event.image} alt={event.title} className="w-full h-48 object-cover rounded-t-lg mb-4" />}
                <div className="flex-shrink-0 bg-purple-600 text-white p-4 rounded-b-lg flex flex-col items-center justify-center text-center -mt-6 z-10 mx-auto w-24 h-24">
                  <span className="text-2xl font-bold">{event.month}</span>
                  <span className="text-4xl font-extrabold">{event.day}</span>
                </div>
                <div className="mt-4 flex-grow text-center">
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">{event.title}</h3>
                  {event.location && <p className="text-gray-600 text-sm mb-1"><i className="fas fa-map-marker-alt mr-2"></i>{event.location}</p>}
                  <p className="text-gray-700 text-sm">{event.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-10">
            <a href="#" className="inline-block bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-6 rounded-md shadow-lg transition-colors">
              {content.eventsSummary.cta}
            </a>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-16 bg-gradient-to-r from-purple-600 to-purple-800 text-white rounded-lg shadow-lg mb-12">
          <h2 className="text-3xl font-bold text-center mb-4">{content.testimonials.title}</h2>
          <p className="text-lg text-center mb-10 max-w-3xl mx-auto">{content.testimonials.subtitle}</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-8">
            {content.testimonials.items.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md p-6 text-gray-800 flex flex-col items-center text-center">
                <img src={testimonial.image} alt={testimonial.name} className="w-20 h-20 rounded-full object-cover mb-4 border-2 border-purple-600" />
                <p className="italic text-lg mb-4">"{testimonial.quote}"</p>
                <p className="font-semibold text-purple-700">{testimonial.name}</p>
                <p className="text-sm text-gray-600">{testimonial.role}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Call To Action Section */}
        <section
          className="py-16 bg-purple-800 text-white rounded-lg shadow-xl text-center relative overflow-hidden"
          style={{ backgroundImage: `url(${content.callToAction.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        >
          <div className="absolute inset-0 bg-black opacity-50 rounded-lg"></div> {/* Overlay */}
          <div className="relative z-10">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">{content.callToAction.title}</h2>
            <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto">{content.callToAction.subtitle}</p>
            <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4">
              <a href="#" className="bg-white text-purple-800 hover:bg-gray-200 font-bold py-3 px-6 rounded-md shadow-lg transition-colors">
                {content.callToAction.cta1}
              </a>
              <a href="#" className="bg-yellow-400 text-purple-800 hover:bg-yellow-500 font-bold py-3 px-6 rounded-md shadow-lg transition-colors">
                {content.callToAction.cta2}
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

// --- Page: About ---
const About = ({ content }) => {
  return (
    <div className="bg-gray-50 pb-12">
      <Hero title={content.hero.title} subtitle={content.hero.subtitle} image={content.hero.image} />

      <div className="container mx-auto px-4">
        {/* Intro Section */}
        <section className="bg-white rounded-lg shadow-lg p-8 mb-12 flex flex-col lg:flex-row items-center justify-center gap-8">
          <div className="lg:w-2/3">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">{content.intro.title}</h2>
            {content.intro.paragraphs.map((para, index) => (
              <p key={index} className="text-gray-700 text-lg mb-4 leading-relaxed">{para}</p>
            ))}
          </div>
          <div className="lg:w-1/3 flex justify-center">
            <img src={content.intro.image} alt="EPLC Introduction" className="rounded-lg shadow-md w-full max-w-xs h-auto" />
          </div>
        </section>

        {/* Mid-Page Image Section for About */}
        <Hero title={content.midPageImage.title} subtitle={content.midPageImage.subtitle} image={content.midPageImage.image} />

        {/* Vision, Mission, Tagline */}
        <section className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="bg-purple-100 rounded-lg shadow-md p-6 text-center flex flex-col items-center">
            <i className={`${content.visionMissionTagline.visionIcon} text-purple-600 text-5xl mb-4`}></i>
            <h3 className="text-2xl font-bold text-purple-800 mb-3">{content.visionMissionTagline.visionTitle}</h3>
            <p className="text-purple-700 text-lg">{content.visionMissionTagline.visionText}</p>
          </div>
          <div className="bg-green-100 rounded-lg shadow-md p-6 text-center flex flex-col items-center">
            <i className={`${content.visionMissionTagline.missionIcon} text-green-600 text-5xl mb-4`}></i>
            <h3 className="text-2xl font-bold text-green-800 mb-3">{content.visionMissionTagline.missionTitle}</h3>
            <p className="text-green-700 text-lg">{content.visionMissionTagline.missionText}</p>
          </div>
          <div className="bg-yellow-100 rounded-lg shadow-md p-6 text-center flex flex-col items-center">
            <i className={`${content.visionMissionTagline.taglineIcon} text-yellow-600 text-5xl mb-4`}></i>
            <h3 className="text-2xl font-bold text-yellow-800 mb-3">{content.visionMissionTagline.taglineTitle}</h3>
            <p className="text-yellow-700 text-lg">{content.visionMissionTagline.taglineText}</p>
          </div>
        </section>

        {/* Values Section */}
        <section className="bg-white rounded-lg shadow-lg p-8 mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4 text-center">{content.values.title}</h2>
          <p className="text-lg text-gray-600 mb-10 text-center max-w-3xl mx-auto">{content.values.subtitle}</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {content.values.items.map((item, index) => (
              <div key={index} className="border-l-4 border-purple-600 pl-4 py-2 bg-gray-50 rounded-md p-4 shadow-sm flex items-start gap-3">
                {item.icon && <i className={`${item.icon} text-purple-600 text-2xl mt-1`}></i>}
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">{item.title}</h3>
                  <p className="text-gray-700">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Guiding Principles */}
        <section
          className="py-16 bg-purple-700 text-white rounded-lg shadow-lg p-8 mb-12 text-center relative overflow-hidden"
          style={{ backgroundImage: `url(${content.guidingPrinciples.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        >
          <div className="absolute inset-0 bg-black opacity-50 rounded-lg"></div> {/* Overlay */}
          <div className="relative z-10">
            <h2 className="text-3xl font-bold mb-4">{content.guidingPrinciples.title}</h2>
            <p className="text-lg">{content.guidingPrinciples.description}</p>
          </div>
        </section>

        {/* Board of Directors Section */}
        <section className="bg-white rounded-lg shadow-lg p-8 mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4 text-center">{content.boardOfDirectors.title}</h2>
          <p className="text-lg text-gray-600 mb-6 text-center max-w-3xl mx-auto">{content.boardOfDirectors.subtitle}</p>
          <p className="text-gray-700 mb-4 leading-relaxed">{content.boardOfDirectors.intro}</p>
          <p className="text-gray-700 mb-8 leading-relaxed">{content.boardOfDirectors.responsibilitiesSummary}</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {content.boardOfDirectors.members.map((member, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-6 shadow-md flex flex-col items-center text-center space-y-3">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-24 h-24 rounded-full object-cover border-4 border-purple-600 shadow-md"
                  onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/100x100/e0e0e0/000000?text=NA"; }} // Fallback
                />
                <div>
                  <h3 className="text-xl font-semibold text-gray-800">{member.name}</h3>
                  <p className="text-purple-600 font-medium">{member.title}</p>
                  <p className="text-sm text-gray-600">{member.roleDetail}</p>
                  <p className="text-gray-500 text-xs">Joined: {member.date}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Affiliates & Funders Section */}
        <section className="bg-white rounded-lg shadow-lg p-8 mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4 text-center">{content.affiliatesAndFunders.title}</h2>
          <p className="text-lg text-gray-600 mb-8 text-center max-w-3xl mx-auto">{content.affiliatesAndFunders.subtitle}</p>

          <div className="flex flex-col lg:flex-row items-center justify-center gap-8">
            <div className="lg:w-1/2">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Affiliates</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">{content.affiliatesAndFunders.affiliatesIntro}</p>
              <div className="flex flex-wrap justify-center items-center gap-6 mb-10">
                {content.affiliatesAndFunders.logos.slice(0, 3).map((logo, index) => (
                  <img key={`affiliate-${index}`} src={logo} alt={`Partner ${index + 1}`} className="max-h-20 w-auto rounded-lg shadow-md" />
                ))}
              </div>

              <h3 className="text-2xl font-bold text-gray-800 mb-4">Funders</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">{content.affiliatesAndFunders.fundersIntro}</p>
              <div className="flex flex-wrap justify-center items-center gap-6">
                {content.affiliatesAndFunders.logos.slice(3).map((logo, index) => (
                  <img key={`funder-${index}`} src={logo} alt={`Funder ${index + 1}`} className="max-h-20 w-auto rounded-lg shadow-md" />
                ))}
              </div>
            </div>
            <div className="lg:w-1/2 flex justify-center">
              <img src={content.affiliatesAndFunders.image} alt="Affiliates and Funders" className="rounded-lg shadow-md w-full max-w-md h-auto" />
            </div>
          </div>
        </section>

        {/* Strategic Priorities Section */}
        <section className="bg-purple-50 rounded-lg shadow-lg p-8 flex flex-col lg:flex-row items-center justify-center gap-8">
          <div className="lg:w-2/3">
            <h2 className="text-3xl font-bold text-gray-800 mb-4 text-center lg:text-left">{content.strategicPriorities.title}</h2>
            <p className="text-lg text-gray-600 mb-8 text-center lg:text-left">{content.strategicPriorities.subtitle}</p>
            <ul className="list-disc list-inside text-gray-700 space-y-3 md:grid md:grid-cols-2 lg:grid-cols-3">
              {content.strategicPriorities.items.map((item, index) => (
                <li key={index} className="bg-white p-4 rounded-md shadow-sm border-l-4 border-purple-500">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:w-1/3 flex justify-center">
            <img src={content.strategicPriorities.image} alt="Strategic Priorities" className="rounded-lg shadow-md w-full max-w-xs h-auto" />
          </div>
        </section>
      </div>
    </div>
  );
};

// --- Page: Services ---
const Services = ({ content }) => {
  return (
    <div className="bg-gray-50 pb-12">
      <Hero title={content.hero.title} subtitle={content.hero.subtitle} image={content.hero.image} />

      <div className="container mx-auto px-4">
        {/* Intro Section */}
        <section className="bg-white rounded-lg shadow-lg p-8 mb-12 flex flex-col lg:flex-row items-center justify-center gap-8">
          <div className="lg:w-2/3">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">{content.intro.title}</h2>
            <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto">{content.intro.subtitle}</p>
            <ul className="list-none grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {content.intro.items.map((item, index) => (
                <li key={index} className="bg-purple-50 text-purple-800 font-semibold p-4 rounded-md shadow-sm">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:w-1/3 flex justify-center">
            <img src={content.intro.image} alt="Services Introduction" className="rounded-lg shadow-md w-full max-w-xs h-auto" />
          </div>
        </section>

        {/* Mid-Page Image Section for Services */}
        <Hero title={content.midPageImage.title} subtitle={content.midPageImage.subtitle} image={content.midPageImage.image} />

        {/* Detailed Services Section */}
        <section className="bg-white rounded-lg shadow-lg p-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-4 text-center">{content.detailedServices.title}</h2>
          <p className="text-lg text-gray-600 mb-10 text-center max-w-3xl mx-auto">{content.detailedServices.subtitle}</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {content.detailedServices.items.map((service, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-6 shadow-md border-t-4 border-purple-600 flex flex-col items-center text-center">
                {service.icon && <i className={`${service.icon} text-purple-600 text-4xl mb-3`}></i>}
                <h3 className="text-xl font-semibold text-gray-800 mb-3">{service.title}</h3>
                <p className="text-gray-700 leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

// --- Page: Events ---
const Events = ({ content }) => {
  return (
    <div className="bg-gray-50 pb-12">
      <Hero title={content.hero.title} subtitle={content.hero.subtitle} image={content.hero.image} />

      <div className="container mx-auto px-4">
        {/* Mid-Page Image Section for Events */}
        <Hero title={content.midPageImage.title} subtitle={content.midPageImage.subtitle} image={content.midPageImage.image} />

        {content.sections.map((section, sectionIndex) => (
          <section key={sectionIndex} className="bg-white rounded-lg shadow-lg p-8 mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4 text-center">{section.heading}</h2>
            <p className="text-lg text-gray-600 mb-10 text-center max-w-3xl mx-auto">{section.subtitle}</p>
            {section.events.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {section.events.map((event, eventIndex) => (
                  <div key={eventIndex} className="bg-gray-100 rounded-lg shadow-md p-6 flex flex-col">
                    {event.image && <img src={event.image} alt={event.title} className="w-full h-48 object-cover rounded-t-lg mb-4 transform transition-transform duration-300 hover:scale-105" />}
                    <div className="flex-shrink-0 bg-purple-600 text-white p-4 rounded-b-lg flex flex-col items-center justify-center text-center -mt-6 z-10 mx-auto w-24 h-24">
                      <span className="block text-xl font-bold">{event.month}</span>
                      <span className="block text-3xl font-extrabold">{event.day}</span>
                      {event.year && <span className="block text-sm opacity-80">{event.year}</span>}
                    </div>
                    <div className="mt-4 flex-grow text-center">
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">{event.title}</h3>
                      {event.time && <p className="text-gray-600 text-sm mb-1"><i className="far fa-clock mr-2"></i>{event.time}</p>}
                      {event.venue && <p className="text-gray-600 text-sm mb-1"><i className="fas fa-map-marker-alt mr-2"></i>{event.venue}</p>}
                      <p className="text-gray-700 text-sm mt-2">{event.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-center text-gray-600">No events to display in this section yet.</p>
            )}
          </section>
        ))}
      </div>
    </div>
  );
};

// --- Page: Contact ---
const Contact = ({ content, contactInfo }) => {
  return (
    <div className="bg-gray-50 pb-12">
      <Hero title={content.hero.title} subtitle={content.hero.subtitle} image={content.hero.image} />

      <div className="container mx-auto px-4">
        {/* Get In Touch Section */}
        <section className="bg-white rounded-lg shadow-lg p-8 mb-12 flex flex-col lg:flex-row items-center justify-center gap-8">
          <div className="lg:w-1/2">
            <h2 className="text-3xl font-bold text-gray-800 mb-4 text-center lg:text-left">{content.getInTouch.title}</h2>
            <p className="text-lg text-gray-600 mb-8 text-center lg:text-left">{content.getInTouch.description}</p>

            <div className="grid grid-cols-1 gap-8">
              {/* Contact Form Placeholder */}
              <div className="bg-purple-50 p-6 rounded-lg shadow-md">
                <h3 className="text-2xl font-semibold text-purple-800 mb-4">Send Us a Message</h3>
                <form className="space-y-4">
                  <div>
                    <label htmlFor="name" className="block text-gray-700 text-sm font-bold mb-2">Name</label>
                    <input type="text" id="name" name="name" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Your Name" />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">Email</label>
                    <input type="email" id="email" name="email" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="your@example.com" />
                  </div>
                  <div>
                    <label htmlFor="subject" className="block text-gray-700 text-sm font-bold mb-2">Subject</label>
                    <input type="text" id="subject" name="subject" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Subject of your message" />
                  </div>
                  <div>
                    <label htmlFor="message" className="block text-gray-700 text-sm font-bold mb-2">Message</label>
                    <textarea id="message" name="message" rows="5" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Your message..."></textarea>
                  </div>
                  <button type="submit" className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded-md shadow-lg transition-colors">
                    Send Message
                  </button>
                </form>
              </div>

              {/* Contact Details */}
              <div className="bg-gray-100 p-6 rounded-lg shadow-md">
                <h3 className="text-2xl font-semibold text-gray-800 mb-4">Our Details</h3>
                <p className="flex items-center mb-4 text-gray-700 text-lg">
                  <i className="fas fa-map-marker-alt mr-3 text-purple-600"></i>
                  {contactInfo.address}
                </p>
                <p className="flex items-center mb-4 text-gray-700 text-lg">
                  <i className="fas fa-phone mr-3 text-purple-600"></i>
                  {contactInfo.phone}
                </p>
                <p className="text-gray-600 text-base mb-4">{content.getInTouch.phoneContact}</p>
                <p className="flex items-center mb-4 text-gray-700 text-lg">
                  <i className="fas fa-envelope mr-3 text-purple-600"></i>
                  {contactInfo.email}
                </p>
                <p className="flex items-center text-gray-700 text-lg">
                  <i className="fas fa-dollar-sign mr-3 text-purple-600"></i>
                  Donation Email: {contactInfo.donationEmail}
                </p>
              </div>
            </div>
          </div>
          <div className="lg:w-1/2 flex justify-center">
            <img src={content.getInTouch.image} alt="Get In Touch" className="rounded-lg shadow-md w-full max-w-sm h-auto" />
          </div>
        </section>

        {/* Mid-Page Image Section for Contact */}
        <Hero title={content.midPageImage.title} subtitle={content.midPageImage.subtitle} image={content.midPageImage.image} />

        {/* Visit Office Section */}
        <section className="bg-white rounded-lg shadow-lg p-8 mb-12 flex flex-col lg:flex-row-reverse items-center justify-center gap-8">
          <div className="lg:w-1/2">
            <h2 className="text-3xl font-bold text-gray-800 mb-4 text-center lg:text-right">{content.visitOffice.title}</h2>
            <p className="text-lg text-gray-600 mb-8 text-center lg:text-right">{content.visitOffice.description}</p>
            <div className="grid grid-cols-1 gap-8">
              {/* Office Hours */}
              <div className="bg-purple-50 p-6 rounded-lg shadow-md">
                <h3 className="text-2xl font-semibold text-purple-800 mb-4">Office Hours</h3>
                <ul className="space-y-2 text-gray-700 text-lg">
                  {content.visitOffice.officeHours.map((hour, index) => (
                    <li key={index} className="flex items-center"><i className="far fa-clock mr-3 text-purple-600"></i>{hour}</li>
                  ))}
                </ul>
              </div>
              {/* Map Placeholder */}
              <div className="bg-gray-100 p-6 rounded-lg shadow-md flex flex-col items-center justify-center">
                <h3 className="text-2xl font-semibold text-gray-800 mb-4">Our Location</h3>
                <img src={content.visitOffice.mapPlaceholder} alt="Office Location" className="w-full h-auto max-h-80 object-cover rounded-md mb-4" />
                <img src={content.visitOffice.officeImage} alt="Office Interior" className="w-full h-auto max-h-80 object-cover rounded-md" />
              </div>
            </div>
            <p className="text-gray-600 text-sm mt-6 text-center lg:text-right">{content.visitOffice.accessibilityNote}</p>
          </div>
          <div className="lg:w-1/2 flex justify-center">
            {/* The images are already inside the inner div, so no need for another img tag here */}
          </div>
        </section>

        {/* FAQ Section */}
        <section className="bg-white rounded-lg shadow-lg p-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-4 text-center">{content.faq.title}</h2>
          <p className="text-lg text-gray-600 mb-10 text-center max-w-3xl mx-auto">{content.faq.subtitle}</p>
          <div className="space-y-4">
            {content.faq.questions.map((faq, index) => (
              <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
                <details className="group">
                  <summary className="flex justify-between items-center px-6 py-4 cursor-pointer bg-gray-50 hover:bg-gray-100 text-gray-800 font-semibold text-lg">
                    {faq.question}
                    <span className="transform transition-transform duration-200 group-open:rotate-180">
                      <i className="fas fa-chevron-down"></i>
                    </span>
                  </summary>
                  <p className="px-6 py-4 text-gray-700 bg-white border-t border-gray-200 leading-relaxed">
                    {faq.answer}
                  </p>
                </details>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

// --- Page: Donate ---
const Donate = ({ contactInfo }) => {
  return (
    <div className="bg-gray-50 pb-12">
      <Hero
        title="Support Our Mission"
        subtitle="Your generous contributions empower us to continue our vital work in the community."
        image="https://i.imgur.com/pR3tiEC.jpeg"
      />
      <div className="container mx-auto px-4 py-8 bg-white rounded-lg shadow-lg mb-12">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">Make a Donation</h2>
        <p className="text-lg text-center text-gray-700 mb-8 max-w-2xl mx-auto">
          Thank you for considering a donation to the Eritrean Parents Liaison Council. Your support helps us provide essential services and programs to newcomer families and children.
        </p>

        <div className="bg-purple-50 p-8 rounded-lg shadow-md text-center max-w-xl mx-auto">
          <h3 className="text-2xl font-semibold text-purple-800 mb-4">How to Donate</h3>
          <p className="text-gray-700 text-lg mb-4">
            You can send your e-transfer or PayPal donation to our official email address:
          </p>
          <p className="text-purple-600 font-bold text-xl md:text-2xl mb-6 break-words">
            {contactInfo.donationEmail}
          </p>
          <p className="text-gray-700 text-lg mb-6">
            For direct payment, click the button below to open your email client.
          </p>
          <a
            href={`mailto:${contactInfo.donationEmail}?subject=Donation to EPLC`}
            className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition-colors text-lg"
          >
            <i className="fas fa-envelope mr-2"></i> Send Donation Email
          </a>
          <p className="text-gray-500 text-sm mt-6">
            Please include your full name and address in the notes if you require a tax receipt.
          </p>
        </div>
      </div>
    </div>
  );
};


function App() {
  const [currentPage, setCurrentPage] = useState('home');

  // Simulate routing based on currentPage state
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <Home content={content.en.home} contactInfo={contactInfo} />;
      case 'about':
        return <About content={content.en.about} contactInfo={contactInfo} />;
      case 'services':
        return <Services content={content.en.services} contactInfo={contactInfo} />;
      case 'events':
        return <Events content={content.en.events} contactInfo={contactInfo} />;
      case 'contact':
        return <Contact content={content.en.contact} contactInfo={contactInfo} />;
      case 'donate':
        return <Donate contactInfo={contactInfo} />; // Render the new Donate component
      default:
        return <Home content={content.en.home} contactInfo={contactInfo} />;
    }
  };

  // Ensure the HTML root element is 'ltr' as English is the only language
  useEffect(() => {
    document.documentElement.dir = 'ltr';
  }, []);


  // Pass current page to Header for active link
  return (
    <div className="flex flex-col min-h-screen font-inter">
      <Header
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        navbarContent={content.en.navbar} // Always use English navbar content
        contactInfo={contactInfo}
      />
      <main className="flex-grow">
        {renderPage()}
      </main>
      <Footer contactInfo={contactInfo} />
    </div>
  );
}

export default App;
